import benefitsJson from "../../data/emailMarketingBenefits.json";
import * as FaIcons from "react-icons/fa"; // Import all FA icons

export default function Section4() {
  const benefitsData = benefitsJson;

  return (
    <div className="Section4 p-[2%] my-[40px] md:mb-[4%] md:mt-[5%] text-center bg-[url('/public/assets/magento-rectangle.png')]">
      <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-white my-[0.67em]">
        Why Choose Mean3
      </h2>

      <div className="w-[80%] md:flex justify-center gap-y-[19px] md:gap-y-[30px] mx-auto md:pt-5 mb-[25px] flex-wrap">
        {benefitsData.map(({ title, text, icon }, index) => {
          const IconComponent = FaIcons[icon]; // dynamically pick FA icon
          return (
            <div
              key={title + index}
              className="bg-white rounded-[10px] text-center my-5 md:m-[10px_8px] p-[20px] w-full md:w-[25%] text-[#373737] shadow-md hover:shadow-lg transition"
            >
              {/* Icon */}
              {IconComponent && (
                <div className="flex justify-center mb-4">
                  <IconComponent size={36} className="text-red-500" />
                </div>
              )}

              {/* Title */}
              <h3 className="text-black font-bold my-[0.67em] text-[16px] leading-[26px]">
                {title}
              </h3>

              {/* Text */}
              <p className="text-[14px] mb-3 font-open">{text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
